
import { defineComponent } from "vue";
import AutoComplete from "primevue/autocomplete";

export default defineComponent({
  name: "MedicineSearch",
  components: { AutoComplete },
  data() {
    return {
      selectedMedication: "",
      searchTerms: [],
      isFocused: false,
      animatedPlaceholder: "",
      placeholderOptions: ["Ozempic", "Semaglutide", "Atorvastatin", "Nabumetone"],
      currentIndex: 0,
      isDeleting: false,
      typingInterval: null as number | null,
    };
  },
  mounted() {
    this.startTypingAnimation();
  },
  methods: {
    onMedicationTermSearchComplete(event) {
      if (event.query.length >= 3) {
        this.fetchMedicationTerm(event.query);
      }
    },
    async fetchMedicationTerm(query) {
      try {
        const response = await this.$store.dispatch("GetPharmacyMedicineSearchTerm", {
          query: query,
        });
        this.searchTerms = response.data;
        console.log("Data:", this.searchTerms);
      } catch (error) {
        console.error("Failed to fetch medication:", error);
      }
    },
    async onMatchedTermClick(query) {
      try {
        const response = await this.$store.dispatch("GetPharmacyMedicineSearchTermResults", { query: query });

        // Emit the response to the parent component so it can trigger openMedPicker.
        this.$emit("medicationSelected", response.data);
      } catch (error) {
        console.error("Failed to fetch medication details:", error);
      }
    },
    startTypingAnimation() {
      const baseText = "Search ";
      let charIndex = 0;
      let word = this.placeholderOptions[this.currentIndex];

      this.typingInterval = setInterval(() => {
        if (this.isFocused || this.selectedMedication) {
          this.animatedPlaceholder = "";
          return;
        }

        if (!this.isDeleting) {
          this.animatedPlaceholder = baseText + word.substring(0, charIndex++);
          if (charIndex > word.length + 5) {
            this.isDeleting = true;
          }
        } else {
          this.animatedPlaceholder = baseText + word.substring(0, charIndex--);
          if (charIndex === 0) {
            this.isDeleting = false;
            this.currentIndex = (this.currentIndex + 1) % this.placeholderOptions.length;
            word = this.placeholderOptions[this.currentIndex];
          }
        }
      }, 100);
    },
  },
});
